/* src/app/dialogs/activation-account-editor/activation-account-editor.component.css */
.warn {
  background: #ffb601;
  padding: 10px;
  margin-bottom: 10px;
  font-size: 0.8em;
  float: left;
  border-radius: 5px;
  text-align: center;
  width: 100%;
}
/*# sourceMappingURL=activation-account-editor.component-EVVSJW5R.css.map */
